import Subject from "../cse4sub/Subject";
import React from 'react'

export default function BeeLab() {
  return (
    <div>
       <Subject title="Basic Electrical Engineering Lab(ASH208)" sub="BEE LAB" syllabus="#"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}